import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

const ContactForm = () => {
  const form = useRef();
  const [errors, setErrors] = useState({});

  const validate = () => {
    let newErrors = {};
    const email = form.current.user_email.value.trim();
    const number = form.current.user_number.value.trim();

    // ✅ Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      newErrors.email = "Please enter a valid email address";
    }

    // ✅ Number validation (exactly 10 digits)
    const numberRegex = /^[0-9]{10}$/;
    if (!numberRegex.test(number)) {
      newErrors.number = "Please enter a valid 10-digit number";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // true if no errors
  };

  const sendEmail = (e) => {
    e.preventDefault();

    if (!validate()) return; // ❌ stop if invalid

    emailjs
      .sendForm(
        "service_p5ycnb5", // replace with your actual service ID
        "template_6sjyr3s", // replace with your template ID
        form.current,
        "_krs3EVvFymQIAOI8" // replace with your public key
      )
      .then(
        (result) => {
          alert("Message sent successfully!");
        },
        (error) => {
          alert("Failed to send message.");
        }
      );

    e.target.reset(); // Clear form after sending
    setErrors({}); // Clear errors
  };

  return (
    <form
      ref={form}
      onSubmit={sendEmail}
      className="flex md:h-full flex-col justify-center items-center p-4 md:p-10 bg-neutral-200"
    >
      <div className="w-full max-w-2xl flex flex-col justify-center items-center rounded-lg bg-gray-50">
        <div className="px-6 md:px-10">
          <h1 className="pt-5 text-2xl poppins-bold uppercase text-gray-700 text-center">
            Contact Form
          </h1>
          <hr className="border-t-2 border-gray-400 w-full" />
        </div>

        <div className="flex flex-col w-full px-6 md:px-10 pb-10 pt-6 gap-5">
          <input
            name="user_name"
            className="border border-blue-400 text-sm md:text-lg p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300"
            type="text"
            placeholder="Name"
            required
          />

          <input
            name="user_email"
            className="border border-blue-400 text-sm md:text-lg p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300"
            type="email"
            placeholder="Email"
            required
          />
          {errors.email && (
            <p className="text-red-500 text-sm">{errors.email}</p>
          )}
          <input
            name="user_number"
            className="border border-blue-400 text-sm md:text-lg p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300"
            type="tel"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength="10"
            placeholder="Number"
            required
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, ""); // allow only digits
            }}
          />
          {errors.number && (
            <p className="text-red-500 text-sm">{errors.number}</p>
          )}

          <textarea
            name="message"
            className="border border-blue-400 text-sm md:text-lg p-2 resize-y w-full rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300"
            rows="5"
            placeholder="Type your message..."
          ></textarea>

          <button
            type="submit"
            className="w-full bg-gradient-to-r text-sm md:text-xl from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 poppins-semibold p-3 md:p-4 rounded-lg text-white uppercase"
          >
            Send Message
          </button>
        </div>
      </div>
    </form>
  );
};

export default ContactForm;
